const UnifiedCompletedWarning = ({ onBackToLogin, onContinueAnyway }) => {
  return (
    <div className="sh_login">
      <div className="sh_login-bleed">
        <main className="sh_login-bg">
          <div className="container sh_login-container">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="d-flex justify-content-center">
                  <div className="sh_login-card">
                    <div className="sh_login-card-inner text-center px-4 py-4">
                      <i className="fas fa-check-circle mb-3" style={{ fontSize: "3.5rem", color: "#28a745" }} aria-hidden />
                      <h4 className="font-weight-bold text-dark mb-3">Your Patient Form is Completed Already</h4>
                      <hr className="my-3" />
                      <div className="d-flex flex-column flex-sm-row justify-content-center" style={{ gap: "0.75rem" }}>
                        <button type="button" className="btn sh_login-btn flex-fill" onClick={onBackToLogin}>
                          Back to Login
                        </button>
                        <button type="button" className="btn sh_login-btn flex-fill" onClick={onContinueAnyway}>
                          Continue Anyway
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default UnifiedCompletedWarning;
